'use client'

export interface Field {
  id: string
  model: string
  type?: string
  placeholder: string
  required: boolean
  rows?: number
  options?: string[]
}

function Input({field}: {field: Field}) {
  const className = `w-full rounded-lg p-4 border border-primary-400 outline-none bg-background`

  return (
    <div className="flex flex-col gap-1">
      <div className="relative w-full">
        {field?.type === 'textarea' ? (
          <textarea
            id={field.id}
            name={field.model}
            placeholder={field.placeholder}
            required={field.required}
            className={className}
            rows={field.rows ? field.rows : 1}
          />
        ) : (
          <input
            id={field.id}
            type={field?.type ?? 'text'}
            name={field.model}
            placeholder={field.placeholder}
            required={field.required}
            className={className}
          />
        )}
      </div>
    </div>
  )
}

export default Input
